export const IntegrationJMJStatus = [
  { title: () => 'Pendente \n', src: "pending-clock-alert-outline.svg", enum: 'PENDING' },
  { title: () => 'Em andamento \n', src: "running-clock-alert-outline.svg", enum: 'RUNNING' },
  { title: () => 'Cancelado \n', src: "canceled-clock-alert-outline.svg", enum: 'CANCELED' },
  { title: (closedAt) => 'Finalizado \nData: '+ closedAt, src: "finished-clock-alert-outline.svg", enum: 'FINISHED' },
];



